import * as Yup from 'yup';
import PropTypes from 'prop-types';

export const ProductPropTypes = PropTypes.shape({
    _id: PropTypes.string,
    productName: PropTypes.string,
    active: PropTypes.bool,
});

export const ProductDefaultProps = {
    _id: undefined,
    productName: '',
    active: true,
};

export const ProductYupSchema = Yup.object().shape({
    productName: Yup.string().min(2, 'Too Short!').max(70, 'Too Long!').required('Required'),
    active: Yup.bool().required('Required'),
});

export default {
    ProductDefaultProps,
    ProductPropTypes,
    ProductYupSchema,
};
